<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="../../../assets/contact_slices/Group 1130@2x.png" style="width: 14px; height: 16px" />
				<div class="cement">账号设置</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-right-paynces">
				<div class="flex-rightTap">
					<div class="flex-rightTap1" @click="clickInfo(1)">
						<div class="all-title" :class="{ 'all-title1': ids == 1 }">基本资料</div>
						<div class="border-top4" v-if="ids == 1"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="clickInfo(2)">
						<div class="all-title" :class="{ 'all-title1': ids == 2 }">密码管理</div>
						<div class="border-top4" v-if="ids == 2"></div>
						<div class="border-top3" v-else></div>
					</div>
				</div>
			</div>
			<div class="border-top" style="margin: 0; padding: 0"></div>

			<template v-if="ids == 1">
				<div class="bj-info">
					<div class="bj-padd">
						<div class="flex-bj">
							<div class="unimage" v-if="userInfo.brokerageEnabled">
								<img src="@/assets/OverviewCertifiedSlices/image 47@2x.png" style="width: 24px; height: 24px" />
								<div class="distributors">分销商 · 分销代码 : {{ userInfo.proxyCode }}</div>
							</div>
							<div class="unimage" v-if="userInfo.realType === 3">
								<div class="certified-name">已实名认证</div>
								<img src="@/assets/Vector@2x (11).png" style="width: 12px; height: 14px; margin-left: 6px" />
							</div>
						</div>
						<div v-if="userInfo.realType === 3 || userInfo.brokerageEnabled" class="border-top" style="margin-top: 15px; padding-top: 16px"></div>
						<div class="felx-list">
							<div class="flex-rightstar">
								<div class="flex-postar">
									<img :src="userInfo.avatar" v-if="userInfo.avatar" style="width: 76px; height: 76px; border-radius: 100px" />
									<img src="@/assets/default-header.png" v-else style="width: 76px; height: 76px; border-radius: 100px" />
									<div class="postar">
										<!-- <img src="@/assets/paynec/Group 1387@2x.png" style="width: 19px; height: 19px" /> -->
									</div>
								</div>
								<div class="click-avatar">
									<!-- <div>头像</div> -->
									<!-- <div class="name-avater">点击头像编辑</div> -->
								</div>
							</div>
							<div class="flex-rightstar">
								<div class="flex-postar">
									<img src="../../../assets/paynec/Group 1482@2x.png" style="width: 48px; height: 48px" />
								</div>
								<div class="click-avatar">
									<div>
										用户昵称 |
										<span style="color: #ff3333" class="span-name" @click="editorClick">编辑</span>
									</div>
									<div class="name-avater">{{ userInfo.nickname }}</div>
								</div>
							</div>
						</div>

						<div class="felx-list">
							<div class="flex-rightstar">
								<div class="flex-postar">
									<img src="../../../assets/paynec/Group 1541@2x.png" style="width: 48px; height: 48px" />
								</div>
								<div class="click-avatar">
									<div>用户ID</div>
									<div class="name-avater">{{ userInfo.id }}</div>
								</div>
							</div>
							<div class="flex-rightstar">
								<div class="flex-postar">
									<img src="../../../assets/paynec/Group 1482@2x (1).png" style="width: 48px; height: 48px" />
								</div>
								<div class="click-avatar">
									<div>手机号</div>
									<div class="name-avater">{{ hideMobile(userInfo.mobile) }}</div>
								</div>
							</div>
						</div>

						<div class="felx-list" v-if="userInfo.idCard">
							<div class="flex-rightstar">
								<div class="flex-postar">
									<img src="../../../assets/paynec/Group 1540@2x.png" style="width: 48px; height: 48px" />
								</div>
								<div class="click-avatar">
									<div>真实姓名</div>
									<div class="name-avater">{{ userInfo.realName }}</div>
								</div>
							</div>
							<div class="flex-rightstar" v-if="userInfo.idCard">
								<div class="flex-postar">
									<img src="../../../assets/paynec/Group 1542@2x.png" style="width: 48px; height: 48px" />
								</div>
								<div class="click-avatar">
									<div>身份证号</div>
									<div class="name-avater">{{ userInfo.idCard }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="height: 50px" v-if="userInfo.realType === 3"></div>
				<div class="real-name" v-if="userInfo.realType !== 3" @click="realnameClick">去实名认证</div>
				<div class="flex-list-name" v-if="userInfo.realType !== 3">
					<img src="../../../assets/paynec/Vector@2x (3).png" style="width: 16px; height: 16px" />
					<div style="margin-left: 3px">实名认证后可提现</div>
				</div>
			</template>
			<popup v-if="showOpout" :userInfo="userInfo" @membMoube="membMoubeClick"></popup>

			<template v-if="ids == 2">
				<div style="display: flex; align-items: center">
					<div class="user-nickname" style="justify-content: space-between">
						<div class="flex-nickname" style="margin-left: 14px">
							<img src="../../../assets/paynec/Group 902@2x.png" style="width: 16px; height: 16px" />
							<div class="name-assets" style="margin-left: 5px">密码</div>
						</div>
						<div class="flex-nickname" style="margin-right: 12px">
							<div>
								<input type="password" v-model="form.password" placeholder="请输入密码" class="inputClat" style="width: 100px" />
							</div>
						</div>
					</div>
<!-- 					<div class="forgot-pwd">忘记密码？</div> -->
				</div>
				<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
					<div class="flex-nickname" style="margin-left: 14px">
						<img src="../../../assets/paynec/Group 1272@2x (1).png" style="width: 16px; height: 16px" />
						<div class="name-assets" style="margin-left: 5px">确认密码</div>
					</div>
					<div class="flex-nickname" style="margin-right: 12px">
						<div>
							<input type="password" v-model="form.oldPassword" placeholder="请输入密码" class="inputClat" style="width: 100px" />
						</div>
					</div>
				</div>
<!-- 
				<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
					<div class="flex-nickname" style="margin-left: 14px">
						<img src="../../../assets/paynec/Group 1272@2x (1).png" style="width: 16px; height: 16px" />
						<div class="name-assets" style="margin-left: 5px">确认新密码</div>
					</div>
					<div class="flex-nickname" style="margin-right: 12px">
						<div>
							<input placeholder="请输入新密码" class="inputClat" style="width: 100px" />
						</div>
					</div>
				</div>
				<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
					<div class="flex-nickname" style="margin-left: 14px">
						<img src="../../../assets/paynec/Group 1269@2x.png" style="width: 15px; height: 16px" />
						<input placeholder="验证码" class="inputClat" style="width: 100px" />
					</div>
					<div class="flex-nickname">
						<div class="flex-ring-inpusClast">
							<img src="../../../assets/Vector@2x.png" />
						</div>
					</div>
				</div> -->
				
				<div class="reset-your" @click="infoUpdatePassword">重置密码</div>
				<div style="height: 110px"></div>
			</template>
		</div>
		<popupPwd v-if="0"></popupPwd>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import popup from './popup.vue';
import popupPwd from './popupPwd.vue';
import { memberUserGet,updatePassword } from '@/utils/api.js';
import { ElMessage } from 'element-plus';
let emit = defineEmits(['reoutnCart']);
let userInfo = ref({});
let showOpout = ref(false);
let form = ref({});

let ids = ref(1);
let dataTime = ref('');
let filter = ref('');
let options = ref([
	{ lable: '1', value: '全部' },
	{ lable: '2', value: '今天' },
	{ lable: '3', value: '最近7天' },
	{ lable: '4', value: '1个月' },
	{ lable: '5', value: '2个月' },
	{ lable: '6', value: '3个月' },
	{ lable: '7', value: '1年' }
]);

const infoatin = async () => {
	let res = await memberUserGet();
	localStorage.setItem('information', JSON.stringify(res.data));
	userInfo.value = res.data ? res.data : {};
};

const realnameClick = () => {
	emit('reoutnCart');
};

const clickInfo = (item) => {
	ids.value = item;
};

const hideMobile = (mobile) => {
	if (!mobile) {
		return '';
	}
	return mobile.substring(0, 3) + '****' + mobile.substring(mobile.length - 4);
};

const editorClick = () => {
	showOpout.value = !showOpout.value;
};

const membMoubeClick = () => {
	editorClick();
	infoatin();
};


const infoUpdatePassword = async () =>{
	const regex = /^(?=.*[A-Za-z])(?=.*\d).{6,18}$/;
	if (!form.value.password) {
		ElMessage({
			message: '请输入密码',
			type: 'error'
		});
		return false;
	}
	if (!form.value.oldPassword) {
		ElMessage({
			message: '请输入确认密码',
			type: 'error'
		});
		return false;
	}
	if(form.value.oldPassword != form.value.password){
		ElMessage({
			message: '密码和确认密码不同',
			type: 'error'
		});
		return false;
	}
	console.log(form.value.password,regex.test(form.value.password))
	if(!regex.test(form.value.password)){
		ElMessage({
			message: '密码（6-18位）必须包含数字和字母',
			type: 'error'
		});
		return false;
	}

	let res = await updatePassword({
		password:form.value.password,
		oldPassword:form.value.oldPassword,
	})
	if(res.msg){
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	}else{
		ElMessage({
			message: '修改成功',
			type: 'success'
		});
	}
}

onMounted(() => {
	infoatin();
});
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.all-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.all-title1 {
	color: #ec3925;
}

.all-title:hover{
	cursor: pointer;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.bj-info {
	width: 544px;
	background: #f7f7f7;
	border-radius: 4px 4px 4px 4px;
	margin-top: 16px;
}
.bj-padd {
	padding: 12px 16px;
}
.flex-bj {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.unimage {
	display: flex;
	align-items: center;
	.distributors {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 13px;
		color: #333333;
		font-style: normal;
		text-transform: none;
		margin-top: 0px;
	}
}
.certified-name {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 13px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.flex-rightstar {
	display: flex;
	align-items: center;
	width: 400px;
}

.click-avatar {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	margin-left: 17px;
	font-style: normal;
	text-transform: none;
}

.name-avater {
	color: #333333;
	font-size: 16px;
	margin-top: 3px;
}
.flex-postar {
	position: relative;
}
.postar {
	position: absolute;
	bottom: 6px;
	right: -1px;
}

.felx-list {
	display: flex;
	align-items: center;
	margin-top: 24px;
}

.real-name {
	width: 162px;
	height: 42px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 12px;
}

.flex-list-name {
	display: flex;
	align-items: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 16px;
}

.forgot-pwd {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff3333;
	margin-top: 20px;
	font-style: normal;
	text-transform: none;
	margin-left: 10px;
}

.flex-ring-inpusClast {
	width: 110px;
	height: 42px;
	background: #ffffff;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	justify-content: center;
}

.reset-your {
	width: 162px;
	height: 42px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	text-align: center;
	line-height: 42px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	font-style: normal;
	text-transform: none;
	margin-left: 19px;
	margin-top: 12px;
}
.span-name{
	cursor: pointer;
}

.reset-your{
	cursor: pointer;
}
</style>
